import { environment } from 'src/environments/environment';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef
 as MatDialogRef  } from '@angular/material/legacy-dialog';
import { ParamterType, SupplementaryEquipment, SupplementaryEquipmentHandout } from '../model/supplementary-equipment-handout.model';
import { HttpService, Identity, ResponseMessage, ResponseStatus, ServiceResponse } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-supplementary-equipment-handout',
  templateUrl: './supplementary-equipment-handout.component.html',
  styleUrls: ['./supplementary-equipment-handout.component.scss']
})
export class SupplementaryEquipmentHandoutComponent implements OnInit {

  handout = new SupplementaryEquipmentHandout();
  isLoading = false;

  identity;

  formGroup = new FormGroup({});

  responseMessages: ResponseMessage[];

  constructor(
    public dialogRef: MatDialogRef<SupplementaryEquipmentHandoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService,
    public translationService: TranslationService) {

    this.isLoading = true;
    this.identity = new Identity();
    this.identity.id = data.visitId;


  }

  ngOnInit() {
    this.http.postWithContext<SupplementaryEquipmentHandout>(`${environment.visitSupplementaryEquipmentHandoutEndpoint}/details`, this.identity).subscribe(
      response => {
        this.handout = response;
        this.isLoading = false;
        this.setupForm();
      }, error => {
        console.error(error);
        this.isLoading = false;
      });
  }

  private setupForm() {
    this.handout.supplementaryEquipments.forEach(se => {
      const equipmentFormGroup = new FormGroup({
        selected: new FormControl(se.selected),
        identifier: new FormControl(se.selectedIdentifier, Validators.required),
        parameter1Value: new FormControl(se.parameter1Value)
      })
      this.formGroup.addControl(se.key, equipmentFormGroup);
    });

    this.formGroup.valueChanges.subscribe(values => {
      this.handout.supplementaryEquipments.forEach(se => {
        se.selected = values[se.key].selected;
        se.selectedIdentifier = values[se.key].identifier;
      });
    });
  }

  isStringParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.STRING;
  }

  isNumberParameter(se: SupplementaryEquipment) {
    return se.parameter1Type === ParamterType.NUMBER;
  }

  isSaveDisabled(): boolean {
    if (this.isLoading) {
      return true;
    }
    // kein check, wenn es keine SE gibt
    if (this.handout.supplementaryEquipments.length === 0) {
      return false;
    }
    // prüfung auf eingabe ungültiger werte
    let validCount = 0;
    for (const se of this.handout.supplementaryEquipments) {
      if (se.selected) {
        if (se.parameter1Type !== ParamterType.NONE && (se.parameter1Value == null || se.parameter1Value.length === 0)) {
          return true;
        } else if (se.availableIdentifiers != null && se.availableIdentifiers.length > 0 && se.selectedIdentifier == null) {
          return true;
        } else {
          validCount += 1;
        }
      }
    }
    return validCount === 0;
  }

  cancel() {
    this.dialogRef.close({ status: 'cancelled' });
  }

  save() {

    this.responseMessages = [];

    this.isLoading = true;

    this.http.postWithContext<ServiceResponse>(`${environment.visitSupplementaryEquipmentHandoutEndpoint}/save`, this.handout).subscribe(
      response => {
        if (response.status === ResponseStatus.SUCCESS) {
          this.dialogRef.close({ status: 'success' });
        } else {
          this.responseMessages = response.responseMessages;
        }
        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.log(error);
      });
  }

  isFormReadonly() {
    return this.isLoading;
  }

}
